import { describeFilter } from 'components/dynamic-content/copy-util';
import { CityPageFilterFragment } from 'utils/gqlReactTypings.generated.d';

export const generateHeroText = (locationName: string, activeFilter?: CityPageFilterFragment) => {
  const { filterDescription, hasFoodOrGoods } = describeFilter(activeFilter);
  return (
    <span>
      Homemade
      <br />
      {filterDescription ?? ''}
      {filterDescription && <br />}
      {hasFoodOrGoods ? '' : 'Food'} Delivery
      <br />
      in {locationName}
    </span>
  );
};
